import { render, staticRenderFns } from "./paper-result-f.vue?vue&type=template&id=5d24deca&scoped=true"
import script from "./paper-result-f.vue?vue&type=script&lang=ts"
export * from "./paper-result-f.vue?vue&type=script&lang=ts"
import style0 from "./paper-result-f.vue?vue&type=style&index=0&id=5d24deca&prod&lang=scss&scoped=true"
import style1 from "./paper-result-f.vue?vue&type=style&index=1&id=5d24deca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d24deca",
  null
  
)

export default component.exports